import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import APP_ROUTES from "../../../../routers/routeConstants";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { deleteService } from "../services/goHireService";

export const useDeleteService = (serviceId: number, options?: { onSuccess?: () => void; onError?: () => void }) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: () => deleteService(serviceId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.all });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.services() });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.trendingServices() });
      navigate(APP_ROUTES.MY_SERVICES);
      options?.onSuccess?.();
    },
    onError: () => {
      options?.onError?.();
    },
  });
};
